import React, { Component, ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { ErrorPageTemplate } from 'components/templates/ErrorPageTemplate';
import { EErrorPageType } from 'models/errorPage';

interface IErrorBoundary {
  resetKey: string;
  children: ReactNode;
}

interface IErrorBoundaryState {
  hasError: boolean;
}

class ErrorBoundary extends Component<IErrorBoundary, IErrorBoundaryState> {
  constructor(props: IErrorBoundary) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): IErrorBoundaryState {
    return { hasError: true };
  }

  componentDidUpdate(prevProps: IErrorBoundary, prevState: IErrorBoundaryState) {
    if (prevState.hasError && prevProps.resetKey !== this.props.resetKey) {
      this.setState({ hasError: false });
    }
  }

  render() {
    if (this.state.hasError) {
      return <ErrorPageTemplate type={EErrorPageType.ServerError} isStatusVisible={false} />;
    }
    return this.props.children;
  }
}

interface IPageErrorBoundary {
  remountKey: number;
  children: ReactNode;
}

export const PageErrorBoundary = ({ remountKey, children }: IPageErrorBoundary) => {
  const { pathname } = useLocation();

  return <ErrorBoundary resetKey={`${pathname}#${remountKey}`}>{children}</ErrorBoundary>;
};
